import config from "../config.json";
import {
  FileValidationParams,
  validateFileHeaders,
} from "../utils/validateFileHeaders";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export interface RoutingPlan {
  id: string;
  name: string;
}

export interface Currency {
  id: string;
  name: string;
  symbol: string;
}

export interface TextFields {
  provider: string;
  percentage: string;
  provider1: string;
  percentage1: string;
  provider2: string;
  percentage2: string;
  provider3: string;
  percentage3: string;
  mcc: string;
  mnc: string;
  rate: string;
  effectiveDate: string;
  operatorName: string;
  countryName: string;
}

export const uploadRoutingPlanExcel = async (
  routingPlanId: string,
  file: File,
  override: boolean,
  textFields: TextFields
): Promise<void> => {
  const extension = file.name.split(".").pop()?.toLowerCase() || "xlsx";

  const validationParams: FileValidationParams = {
    alwaysRequired: [
      textFields.provider,
      textFields.mcc,
      textFields.mnc,
      textFields.rate,
      textFields.effectiveDate,
    ],
    optionalFields: [
      textFields.percentage,
      textFields.provider1,
      textFields.percentage1,
      textFields.provider2,
      textFields.percentage2,
      textFields.provider3,
      textFields.percentage3,
    ],
  };

  await validateFileHeaders(file, extension, validationParams);

  const formData = new FormData();
  formData.append("file", file);

  const endpoint = extension === "csv" ? "csv" : "excel";
  const params = {
    override,
    providerHeader: textFields.provider,
    ...(textFields.percentage
      ? { percentageHeader: textFields.percentage }
      : {}),
    ...(textFields.provider1 ? { provider1Header: textFields.provider1 } : {}),
    ...(textFields.percentage1
      ? { percentage1Header: textFields.percentage1 }
      : {}),
    ...(textFields.provider2 ? { provider2Header: textFields.provider2 } : {}),
    ...(textFields.percentage3
      ? { percentage2Header: textFields.percentage3 }
      : {}),
    ...(textFields.percentage3
      ? { percentage2Header: textFields.percentage3 }
      : {}),
    ...(textFields.provider3 ? { provider3Header: textFields.provider3 } : {}),
    ...(textFields.countryName
      ? { countryHeader: textFields.countryName }
      : {}),
    ...(textFields.percentage3
      ? { percentage3Header: textFields.percentage3 }
      : {}),
    ...(textFields.operatorName
      ? { operatorHeader: textFields.operatorName }
      : {}),

    mccHeader: textFields.mcc,
    mncHeader: textFields.mnc,
    rateHeader: textFields.rate,
    effectiveDateHeader: textFields.effectiveDate,
  };

  try {
    const res = await axiosInstance.put(
      `/routing-plans/${routingPlanId}/${endpoint}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        params,
      }
    );
    return res.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while uploading the routing plan file."
    );
  }
};
